import { SidebarMenuItem } from "@/src/sb/business-layer/types"

const SideBarMenuReportCategoryMock = (): Array<SidebarMenuItem> => {
  return [
    // SideBar Top Menu
    {
      id: 500002,
      destination: "",
      label: "Industries",
      parent_id: 100003,
      category_name: null
    },
    {
      id: 500003,
      destination: "",
      label: "Themes",
      parent_id: 100003,
      category_name: null
    }
  ]
}

export default SideBarMenuReportCategoryMock
